export enum PaymentMethodAvailability {
  AVAILABLE = 'AVAILABLE',
  CREDIT_CARD_NOT_ENABLED = 'CREDIT_CARD_NOT_ENABLED',
  NO_PHONE_NUMBER = 'NO_PHONE_NUMBER',
  WRONG_PAYMENT_METHOD = 'WRONG_PAYMENT_METHOD',
  WRONG_AMOUNT = 'WRONG_AMOUNT',
  CUSTOMER_BLOCKED = 'CUSTOMER_BLOCKED',
}
